import {
  CheckboxProps,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  Typography,
} from "@mui/material";

export const Checkbox = ({
  label,
  bolded,
  value,
  ...rest
}: Omit<CheckboxProps, "value"> & {
  label: string;
  bolded?: boolean;
  value?: boolean | null;
}) => {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          {...rest}
          value={value ?? false}
          checked={value ?? false}
        />
      }
      label={
        bolded ? (
          <Typography sx={{ fontWeight: "700", fontSize: "0.875rem" }}>
            {label}
          </Typography>
        ) : (
          <Typography color="textSecondary">{label}</Typography>
        )
      }
    />
  );
};
